import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Provider } from '@angular/core';

import { HttpBlockRequestInterceptor } from './http-block-request.interceptor';
import { HttpErrorInterceptor } from './http-error.interceptor';
import { HttpServerCacheInterceptor } from './http-server-cache.interceptor';
import { HttpTimeoutInterceptor } from './http-timeout.interceptor';
import { HttpTransferStateInterceptor } from './http-transfer-state.interceptor';

/**
 * !! BE AWARE: Provider declaration order below matters !!
 * 1. HttpTransferStateInterceptor
 * 2. HttpServerCacheInterceptor
 * 3. HttpErrorInterceptor
 * 4. HttpBlockRequestInterceptor
 * 5. HttpTimeoutInterceptor
 */
export const HTTP_INTERCEPTOR_PROVIDERS: Provider[] = [
  HttpTransferStateInterceptor,
  HttpServerCacheInterceptor,
  HttpErrorInterceptor,
  HttpTimeoutInterceptor,
  HttpBlockRequestInterceptor,
  { provide: HTTP_INTERCEPTORS, useExisting: HttpTransferStateInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useExisting: HttpServerCacheInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useExisting: HttpErrorInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useExisting: HttpBlockRequestInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useExisting: HttpTimeoutInterceptor, multi: true }
];
